import React, { useEffect, useState } from 'react';
// import { widgetsNoDatasetOutput } from '../WidgetLibraryGen2';
import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../helpers';
import {
    dataset_list_outputs_json_path,
    dataset_list_json_path
} from '~/routes';
import { useSelector } from 'react-redux';

export const useDatasetSettings = ({
    widget_type,
    widgetId,
    dataset_params = {}
}) => {
    // const selectDatasetOutput = !widgetsNoDatasetOutput.includes(widget_type);
    const selectDatasetOutput = true;
    const selectedDatasets = useSelector(state => state.dashboard.widgets[widgetId].settings?.datasets);
    const selectedWholeDatasets = useSelector(state => state.dashboard.widgets[widgetId].settings?.wholeDatasets);
    const [loadError, setLoadError] = useState(false);

    const datasetsConfigured = () => selectedDatasets.some((d) => d.dataset_id != "");
    const wholeDatasetsConfigured = () => selectedWholeDatasets.some((d) => d.dataset_id != "");

    const {data: datasets, isLoading: datasetsLoading, error: datasetError} = useQuery({
        queryKey: ['dataset_list_outputs', dataset_params],
        queryFn: () => fetchJson(dataset_list_outputs_json_path(dataset_params)),
        enabled: selectDatasetOutput,
    })

    const {data: wholeDatasets, isLoading: wholeDatasetsLoading, error: wholeDatasetsError} = useQuery({
        queryKey: ['dataset_list'],
        queryFn: () => fetchJson(dataset_list_json_path()),
        enabled: !selectDatasetOutput,
    })

    useEffect(() => {
        if (datasetError){
            setLoadError(prev => prev || datasetsConfigured())
        }

        if (wholeDatasetsError){
            setLoadError(prev => prev || wholeDatasetsConfigured())
        }
    }, [datasetError, wholeDatasetsError])

    let res = {
        datasets: datasets || [],
        isLoading: datasetsLoading,
        loadError: loadError
    }
    if (!selectDatasetOutput){
        res = {
            datasets: wholeDatasets || [],
            isLoading: wholeDatasetsLoading,
            loadError: loadError    
        }
    }
    return res;
}
